import React, { useEffect, useState } from "react";

const emojiList = ["✨", "💎", "⭐", "🌟", "💫", "🧑‍🚀", "🦄", "🪐", "🚀"];
const fixedPositions = [
  { top: "10%", left: "15%" }, // top-left
  { top: "12%", left: "70%" }, // top-right
  { top: "20%", left: "35%" }, // upper mid-left
  { top: "35%", left: "85%" }, // upper mid-right
  { top: "40%", left: "10%" }, // mid-left
  { top: "62%", left: "70%" }, // mid-right
  { top: "65%", left: "20%" }, // lower-mid-left
  { top: "12%", left: "95%" }, // lower-mid-right
  { top: "73%", left: "95%" }  // center-bottom
];


export default function FloatingParticles() {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const floatingEmojis = emojiList.map((emoji, i) => ({
      id: `emoji-${i}`,
      emoji,
      ...fixedPositions[i],
      duration: 20 + Math.random() * 10,
      size: 1.5 + Math.random(),
      delay: Math.random() * 5,
      isBoat: false,
    }));

    const boat = {
      id: "boat",
      emoji: "⛵",
      isBoat: true,
      size: 2,
      duration: 25,
      delay: 0,
    };

    setParticles([...floatingEmojis, boat]);
  }, []);

  return (
    <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none">
      {particles.map(({ id, emoji, top, left, duration, size, delay, isBoat }) =>
        isBoat ? (
          <span
            key={id}
            style={{
              fontSize: `${size}rem`,
              animationDuration: `${duration + 10}s`,
              animationDelay: `${delay}s`,
              zIndex: 2,
            }}
            className="absolute animate-boat-float bottom-[8.5%] left-[-10%]"
          >
            {emoji}
          </span>
        ) : (
          <span
            key={id}
            style={{
              top,
              left,
              fontSize: `${size}rem`,
              animationDuration: `${duration}s`,
              animationDelay: `${delay}s`,
            }}
            className="absolute animate-float"
          >
            {emoji}
          </span>
        )
      )}
    </div>
  );
}
